import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { isEmpty } from '@dxb-web-ui-framework/common/utils';
import { recursiveValueAssignmentFromKeyAccess } from '../../utils/recursiveKeyAccess';
import { ClientSideWizardState, ClientSideWizardStateHandlerProps, ClientSideWizardStepConfiguration } from './types';

const defaultClientSideWizardStateHandler = (
  {
    stepData,
    formData,
    setState,
    stepsConfig,
    currentStepId,
    formDataPreloader,
    completedSteps,
  }: ClientSideWizardStateHandlerProps,
  state: ClientSideWizardState,
  callback: (obj: GenericObject) => void,
) => {
  const shouldSetNewStepData = stepData && stepData.stepId;
  if (formData && shouldSetNewStepData) {
    const nextCurrentStepConfig: ClientSideWizardStepConfiguration = formDataPreloader(
      stepsConfig[stepData.stepId as string],
    );
    if (nextCurrentStepConfig && nextCurrentStepConfig.parameters) {
      nextCurrentStepConfig.parameters.stepId = stepData.stepId;
      nextCurrentStepConfig.parameters.components = stepsConfig[stepData.stepId].parameters.components;
      // preload values from initial form state into corresponding form fields
      const availableFields = nextCurrentStepConfig.parameters.components;
      const preloadedFieldData = nextCurrentStepConfig.parameters.preloadedData;
      if (preloadedFieldData) {
        availableFields?.forEach(field =>
          recursiveValueAssignmentFromKeyAccess(field, preloadedFieldData.data[stepData.stepId].values),
        );
      }
    }
    callback({
      formData: isEmpty(nextCurrentStepConfig.parameters.preloadedData)
        ? state.formData
        : nextCurrentStepConfig.parameters.preloadedData,
      currentProcessState: {
        completedSteps,
        stepId: stepData.stepId as string,
        currentStepConfig: nextCurrentStepConfig,
        formData: isEmpty(nextCurrentStepConfig.parameters.preloadedData)
          ? state.formData
          : nextCurrentStepConfig.parameters.preloadedData,
      },
    });
  }
};

export { defaultClientSideWizardStateHandler };
